import React from 'react'

import { Bar, Progress } from './style'

const ProgressBar = ({ progress }: { progress: number }) => {
  return (
    <Bar>
      <Progress $width={`${progress}%`} />
    </Bar>
  )
}

export default ProgressBar
